<template>
    <v-app id="keep">
        <v-navigation-drawer v-model="drawer" class="drawer" fixed clipped app>
            <v-list dense>
                <template v-for="(item, i) in items">
                    <v-layout v-if="item.heading" :key="i" row align-center @click="routeTo(item)">
                        <v-flex xs6>
                            <v-subheader v-if="item.heading">
                                {{ item.heading }}
                            </v-subheader>
                        </v-flex>
                    </v-layout>
                    <v-divider v-else-if="item.divider" :key="i" dark class="my-3"></v-divider>
                    <v-list-tile v-else :key="i" @click="routeTo(item)">
                        <v-list-tile-action>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{ item.text }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>
        </v-navigation-drawer>
        <template>
            <v-toolbar dense color="primary" app fixed clipped-left>
                <v-toolbar-side-icon @click="drawer = !drawer"></v-toolbar-side-icon>
                <span class="title ml-3 mr-5">SuburbanServ</span>
                <v-spacer></v-spacer>
                <!-- <v-btn icon @click="logout()">
                    <v-icon>exit_to_app</v-icon>
                </v-btn> -->
            </v-toolbar>
            <v-content>
                <router-view />
            </v-content>

            <v-footer app fixed color="darkgray">
                <v-spacer></v-spacer>
                <div>Powered by DevInspire (Pty) Ltd. &copy; {{ new Date().getFullYear() }}</div>
            </v-footer>
        </template>
    </v-app>
</template>

<script>
    import LicensingIndicator from '@/components/common/licensing/licensing-indicator'
    import AccountSettings from '@/components/common/account/account-settings';
    import AccountFeatures from '@/components/common/account/account-features';

    export default {
        components: {
            LicensingIndicator,
        },
        data() {
            let self = this;
            return {
                drawer: null,
                items: [{
                        text: self.TranslateText('Home'),
                        route: '/home',
                        icon: 'keyboard_backspace'
                    },
                    {
                        text: self.TranslateText('User List'),
                        route: '/account/user/dashboard',
                        icon: 'people'
                    },
                    {
                        text: self.TranslateText('Account Settings'),
                        route: '/account/settings',
                        icon: 'settings'
                    },
                    {
                        divider: false
                    },
                ],
            }
        },
        methods: {
            routeTo(item) {
                let self = this;
                self.$router.push(item.route);
            },
            logout() {
                let self = this;
                self.$router.push('/home');
            }
        },
        props: {
            source: String
        }
    }
</script>

<style scoped>
    /* .accountDrawer {
        margin-left: 200px;
    } */

    .nav-content {
        padding: 10px;
        cursor: pointer;

    }

    /* .nav-item:hover {
    background: linear-gradient(#b3b3b324, #b3b3b324);
    cursor: pointer;
  } */

    .nav-active {
        background: linear-gradient(#88888824, #0e0e0e24);
    }

    .holder {
        padding: 50px;
        width: 100%;
    }
</style>